// ⚠️ File generato automaticamente da downloadOpenApi.js
// Non modificarlo a mano: verrà sovrascritto.

import { ResponseType } from 'axios';
import { operations } from './api';

export interface OpenApiParamDescriptor {
  readonly name: string;
  readonly description: string | null;
  readonly required: boolean;
}
export type ContentType = 'application/json' | 'multipart/form-data' | 'application/pdf' | 'text/plain' | 'application/octet-stream'| 'application/x-www-form-urlencoded';

export interface OpenApiOperationMeta {
  readonly path: string;
  readonly apiMethod: ApiMethod;
  readonly responseType: ResponseType;
  readonly tags: readonly string[];
  readonly pathParams: readonly OpenApiParamDescriptor[] | null;
  readonly queryParams: readonly OpenApiParamDescriptor[] | null;
  readonly contentType: ContentType;
  readonly exceptionCodes400: readonly string[] | null;
}

export type ApiMethod = 'post' | 'get' | 'delete' | 'patch' | 'put';

export const routesRegistryOpenApi: Record<keyof operations, OpenApiOperationMeta> = {
  "post_app_ai_documentanalyzer_fileanalyzer": {
    "path": "/studi/{uuid}/analyzer",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "post_document_chat": {
    "path": "/ai/multidocumento/{uuid}/chat/{sessionId}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      },
      {
        "name": "sessionId",
        "description": "UUID della sessione da proseguire, oppure '-' per crearne una nuova.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_document_analyzer": {
    "path": "/ai/multidocumento/{uuid}/analyzer/{sessionId}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      },
      {
        "name": "sessionId",
        "description": "UUID della sessione da proseguire, oppure '-' per crearne una nuova.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_document_summarizer": {
    "path": "/ai/multidocumento/{uuid}/summarizer/{sessionId}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      },
      {
        "name": "sessionId",
        "description": "UUID della sessione da proseguire, oppure '-' per crearne una nuova.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_document_clause_generator": {
    "path": "/ai/multidocumento/{uuid}/clause_generator/{sessionId}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      },
      {
        "name": "sessionId",
        "description": "UUID della sessione da proseguire, oppure '-' per crearne una nuova.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_legal_database": {
    "path": "/ai/multidocumento/{uuid}/legal_database/{sessionId}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      },
      {
        "name": "sessionId",
        "description": "UUID della sessione da proseguire, oppure '-' per crearne una nuova.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_vote_message_up": {
    "path": "/ai/vote/{messageId}/up",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "messageId",
        "description": "UUID del Messaggio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_vote_message_down": {
    "path": "/ai/vote/{messageId}/down",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "messageId",
        "description": "UUID del Messaggio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_vote_pareri": {
    "path": "/ai/vote/{messageId}/pareri",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "messageId",
        "description": "UUID del messaggio AI da votare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_genera_documento_con_AI": {
    "path": "/ai/genera_documento",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_genera_atto_con_AI": {
    "path": "/ai/genera_atto",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_totalChat": {
    "path": "/totalchat",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_totalChat_frontend_token": {
    "path": "/totalchat/frontend-token",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "sessionId",
        "description": "UUID della sessione locale TotalChat. Se presente, il token viene emesso per quella sessione.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_totalChat_session": {
    "path": "/totalchat/session/{id}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": [
      {
        "name": "id",
        "description": "ID della sessione TotalChat remota",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_totalChat_feedback": {
    "path": "/totalchat_feedback",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_totalChat_print": {
    "path": "/print",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_delete_total_chat_session": {
    "path": "/sessions/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Total chat"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della sessione locale",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_admin_acquisto_addon": {
    "path": "/api/admin/studi/{uuid}/acquisto-addon",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Acquisto Addon"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_admin_acquisti_addon": {
    "path": "/api/admin/studi/acquisto-addon",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Acquisto Addon"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "page",
        "description": "Indice pagina (0-based).",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Numero di elementi per pagina (1-100).",
        "required": false
      },
      {
        "name": "creatoDaAdmin",
        "description": "Filtro opzionale: se omesso ritorna tutti, se true/false filtra solo quelli creati/non creati da admin.",
        "required": false
      },
      {
        "name": "studioUuid",
        "description": "Filtro opzionale: UUID dello studio. Se omesso ritorna acquisti di tutti gli studi.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_acquisti_addon": {
    "path": "/studio/{uuid}/acquisto-addon",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Acquisto Addon"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "page",
        "description": "Indice pagina (0-based).",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Numero di elementi per pagina (1-100).",
        "required": false
      },
      {
        "name": "creatoDaAdmin",
        "description": "Filtro opzionale: se omesso ritorna tutti, se true/false filtra solo quelli creati/non creati da admin.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_admin_delete_acquisto_addon": {
    "path": "/api/admin/acquisto-addon/{acquistoAddonUuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Acquisto Addon"
    ],
    "pathParams": [
      {
        "name": "acquistoAddonUuid",
        "description": "UUID dell'acquisto addon",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_admin_modify_acquisto_addon": {
    "path": "/api/admin/acquisto-addon/{acquistoAddonUuid}",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Acquisto Addon"
    ],
    "pathParams": [
      {
        "name": "acquistoAddonUuid",
        "description": "UUID dell'acquisto addon",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_addons_seat": {
    "path": "/addons_seat",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Addons"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_getAddons": {
    "path": "/addons",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Addons"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_createAddon": {
    "path": "/addons",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Addons"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_deleteAddon": {
    "path": "/addons/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Addons"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_modifyAddon": {
    "path": "/addons/{uuid}",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Addons"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_admin_brevo_template_list": {
    "path": "/api/admin/brevo-templates",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Brevo Template"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_admin_brevo_template_get": {
    "path": "/api/admin/brevo-templates/{brevoTemplateId}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Brevo Template"
    ],
    "pathParams": [
      {
        "name": "brevoTemplateId",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_admin_brevo_template_update": {
    "path": "/api/admin/brevo-templates/{brevoTemplateId}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Admin Brevo Template"
    ],
    "pathParams": [
      {
        "name": "brevoTemplateId",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_admin_brevo_template_delete": {
    "path": "/api/admin/brevo-templates/{brevoTemplateId}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Admin Brevo Template"
    ],
    "pathParams": [
      {
        "name": "brevoTemplateId",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_coupons_list": {
    "path": "/coupons",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Staff Coupons"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_admin_docxfile_getdocxadminfileslist": {
    "path": "/admin/docx/files",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_import_admin_docx": {
    "path": "/admin/docx/files",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "get_app_admin_docxfile_getdocxfileinjson": {
    "path": "/admin/docx/files/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_admin_docxfile_savedocxadminfile": {
    "path": "/admin/docx/files/{uuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_admin_docx_file": {
    "path": "/admin/docx/files/{uuid}/docx",
    "apiMethod": "get",
    "responseType": "blob",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_admin_docxfile_saveperformanceimportfile": {
    "path": "/admin/docx/files/{uuid}/perfomance",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_admin_docxfile_getdocxadminfileperformance": {
    "path": "/admin/docx/files/{uuid}/performance",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_rating_user_docx": {
    "path": "/admin/docx/users/{userUuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "ADMIN DOCX"
    ],
    "pathParams": [
      {
        "name": "userUuid",
        "description": "UUID del consulente legale",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.docxFile.ratingMissingFields"
    ],
    "contentType": "multipart/form-data"
  },
  "get_documenti_staff": {
    "path": "/staff/{uuid}/documenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Staff"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del membro dello staff.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_dimissioni": {
    "path": "/dimissioni",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studi_list": {
    "path": "/api/admin/studi",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "nome",
        "description": "Filtro per nome dello studio (ricerca parziale)",
        "required": false
      },
      {
        "name": "piano",
        "description": "Filtro per piano (UUID del piano)",
        "required": false
      },
      {
        "name": "dataRinnovoPagamento_from",
        "description": "Filtro data rinnovo pagamento da (YYYY-MM-DD o DD/MM/YYYY)",
        "required": false
      },
      {
        "name": "dataRinnovoPagamento_to",
        "description": "Filtro data rinnovo pagamento a (YYYY-MM-DD o DD/MM/YYYY)",
        "required": false
      },
      {
        "name": "dataIscrizione_from",
        "description": "Filtro data iscrizione da (YYYY-MM-DD o DD/MM/YYYY)",
        "required": false
      },
      {
        "name": "dataIscrizione_to",
        "description": "Filtro data iscrizione a (YYYY-MM-DD o DD/MM/YYYY)",
        "required": false
      },
      {
        "name": "studioFilter",
        "description": "Filtro logico sullo studio.",
        "required": false
      },
      {
        "name": "page",
        "description": "Indice della pagina da restituire (0-based)",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Numero di elementi per pagina",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_info": {
    "path": "/api/admin/studi/{uuid}/info",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_admin_disattiva_studio": {
    "path": "/api/admin/studi/{uuid}/disattiva",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_admin_riattiva_studio": {
    "path": "/api/admin/studi/{uuid}/riattiva",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_admin_remove_studio": {
    "path": "/api/admin/studi/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.studio.notDeactivated",
      "exception.studio.awsDeleteFailed"
    ],
    "contentType": "application/json"
  },
  "post_admin_procedura_pagamento": {
    "path": "/api/admin/studi/{uuid}/procedura_pagamento",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_rinnovi": {
    "path": "/api/admin/studi/{uuid}/rinnovi",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_admin_estendi_trial": {
    "path": "/api/admin/studi/{uuid}/estendi_trial",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.studio.nonTrial",
      "exception.estendiTrialDTO.dataTermineProvaGratuita.dateMustBeFuture",
      "exception.stripe.apiCallFailed"
    ],
    "contentType": "application/json"
  },
  "post_admin_rinnova_piano": {
    "path": "/api/admin/studi/{uuid}/rinnova",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.system.planActionForbidden"
    ],
    "contentType": "application/json"
  },
  "post_admin_crea_trial_period": {
    "path": "/api/admin/studi/{uuid}/trial",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio",
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.system.planActionForbidden",
      "exception.creaTrialPeriodDTO.dataTermineProvaGratuita.dateMustBeFuture"
    ],
    "contentType": "application/json"
  },
  "get_get_templateAnagraficaDefault": {
    "path": "/admin/template_anagrafica/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_modifica_templateAnagraficaDefault": {
    "path": "/admin/template_anagrafica/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_delete_templateAnagraficaDefault": {
    "path": "/admin/template_anagrafica/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_templatesAnagraficaDefault": {
    "path": "/admin/template_anagrafica",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_templateAnagraficaDefault": {
    "path": "/admin/template_anagrafica",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Admin Studio"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_admin_utenti": {
    "path": "/admin/utenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Amministrazione Utenti"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "page",
        "description": "Numero della pagina",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Elementi per pagina",
        "required": false
      },
      {
        "name": "search",
        "description": "Stringa di ricerca per nome, cognome o email",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_rimuovi_utente": {
    "path": "/admin/utenti/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Amministrazione Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_allegato": {
    "path": "/documento/{uuid}/allegato",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Allegati Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento a cui aggiungere l’allegato",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.encryption.decodingUserPrivateKey",
      "exception.encryption.decryptSystemResource",
      "exception.system.userKeyNotFound",
      "exception.validation_error"
    ],
    "contentType": "application/json"
  },
  "get_lista_allegati": {
    "path": "/documento/{uuid}/allegati",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Allegati Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento di cui restituire gli allegati",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_un_allegato": {
    "path": "/allegato/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Allegati Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell’allegato da scaricare/visualizzare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.system.decodingSecret",
      "exception.system.userKeyNotFound",
      "exception.studio.revisoreNonAssociato",
      "exception.studio.redattoreNonAssociato",
      "exception.studio.staffNonAssociato"
    ],
    "contentType": "application/json"
  },
  "delete_rimuovi_allegato": {
    "path": "/allegato/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Allegati Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell’allegato da eliminare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_staff_analytics": {
    "path": "/staff/analytics",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Staff Analytics"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "event",
        "description": "La chiave dell'evento di analytics da ricercare.",
        "required": true
      },
      {
        "name": "page",
        "description": "Il numero di pagina dei risultati.",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Il numero di elementi per pagina.",
        "required": false
      },
      {
        "name": "start_timestamp",
        "description": "Data e ora di inizio dell'intervallo di ricerca (formato Y-m-d H:i:s).",
        "required": false
      },
      {
        "name": "end_timestamp",
        "description": "Data e ora di fine dell'intervallo di ricerca (formato Y-m-d H:i:s).",
        "required": false
      },
      {
        "name": "userId",
        "description": "Filtra per UUID dell'utente.",
        "required": false
      },
      {
        "name": "documentId",
        "description": "Filtra per UUID del documento.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_categorie": {
    "path": "/categorie",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_create_categorie": {
    "path": "/categorie",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_categorie_update": {
    "path": "/categorie/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della categoria da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_categorie_delete": {
    "path": "/categorie/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della categoria da rimuovere",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_categorie_update": {
    "path": "/categorie/{uuid}",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della categoria da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_template_set_categorie": {
    "path": "/templates/{uuid}/categoria",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_template_remove_categoria": {
    "path": "/templates/{uuid}/categoria",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Categoria"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_genera_clausola": {
    "path": "/ai/{uuid}/clausole",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_clausola_ai": {
    "path": "/utenti/{uuid}/ai/clausole",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "AI features"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_salva_clausola_ai": {
    "path": "/utenti/{uuid}/ai/clausole",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_clausole_list": {
    "path": "/clausole",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "user",
        "description": "La uuid dell'utente di cui si vogliono selezionare le clausole",
        "required": false
      },
      {
        "name": "studioUuid",
        "description": "La uuid dello studio di cui si vogliono selezionare le clausole",
        "required": false
      },
      {
        "name": "keyword",
        "description": "Filtro per keyword",
        "required": false
      },
      {
        "name": "page",
        "description": "Pagina",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Elementi per pagina",
        "required": false
      },
      {
        "name": "public",
        "description": "Se true include le clausole pubbliche (user=system). Default: false",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_modifica_clausola": {
    "path": "/clausole",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_clausola": {
    "path": "/clausole",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_export_clausole_personali": {
    "path": "/clausole_personali/export",
    "apiMethod": "post",
    "responseType": "text",
    "tags": [
      "Clausole"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_import_clausole": {
    "path": "/clausole/import",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "delete_a_clausola": {
    "path": "/clausole/{id}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": [
      {
        "name": "id",
        "description": "ID della clausola su Elasticsearch",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_aggiungi_visibilita_clausola": {
    "path": "/clausole/{uuid}/visibility",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.studioUuid.notFound",
      "exception.document.studioNotFound",
      "exception.clausola.accessDenied",
      "exception.clausola.notFound"
    ],
    "contentType": "application/json"
  },
  "post_rimuovi_visibilita_clausola": {
    "path": "/clausole/{uuid}/remove_visibility",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Clausole"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.studioUuid.notFound",
      "exception.document.studioNotFound",
      "exception.clausola.accessDenied",
      "exception.clausola.notFound"
    ],
    "contentType": "application/json"
  },
  "get_utenti_documento": {
    "path": "/documento/{uuid}/utenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_documento_utenti": {
    "path": "/documento/{uuid}/utenti",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_condividi_documento": {
    "path": "/condivisioneDocumento/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della condivisione (MultiDocumentoUtente)",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.code",
      "exception.message"
    ],
    "contentType": "application/json"
  },
  "post_condivisione_documento_admin": {
    "path": "/condivisione_documento/{uuid}/admin",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della condivisione (MultiDocumentoUtente)",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_documento_cedi_controllo": {
    "path": "/documento/{documentoUuid}/consulente/{consulenteUuid}/cedi",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "documentoUuid",
        "description": "UUID del documento",
        "required": true
      },
      {
        "name": "consulenteUuid",
        "description": "UUID del consulente legale destinatario",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_documento_consulenti_disponibili": {
    "path": "/documento/{uuid}/consulenti_disponibili",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_multidocumentoutente_permessi": {
    "path": "/multidocumentoutente/{uuid}/permessi",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Condivisione Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della relazione (MultiDocumentoUtente)",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_consulente_getdocumenticonsulenteloggato": {
    "path": "/consulente/documenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "OpenDotCom"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_getContattiStudio": {
    "path": "/studio/{uuid}/contatti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Contatti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea-contatto": {
    "path": "/studio/{uuid}/contatto",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Contatti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_modifica-contatto": {
    "path": "/studio/{uuid}/contatto/{uuidContatto}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Contatti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      },
      {
        "name": "uuidContatto",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_salva_documento": {
    "path": "/studi/{studioUuid}/documenti/{documentoUuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello Studio in cui creare/aggiornare il documento",
        "required": true
      },
      {
        "name": "documentoUuid",
        "description": "UUID del MultiDocumento (esistente o da creare)",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.documento.associazioneConsulenteRimossa",
      "exception.document.deletedDocument",
      "exception.system.notEnoughStaffMembers",
      "exception.document.failedSavingDocument"
    ],
    "contentType": "application/json"
  },
  "post_go_next": {
    "path": "/v2/documento/{uuid}/next",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_valida": {
    "path": "/v2/documento/{uuid}/valida",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_invalida": {
    "path": "/v2/documento/{uuid}/invalida",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_documento_getazionidocumento": {
    "path": "/documento/{documentoUuid}/azioni",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "documentoUuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_documento_sendnotificadocumento": {
    "path": "/documento/{uuid}/notifica",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_produci_pdf_allegati": {
    "path": "/produci-pdf-allegati/{uuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Allegati Documento",
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento o del template (in base a isTemplate) da cui produrre i PDF.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.template.erroreStampaAllegato",
      "exception.systemError.genericError"
    ],
    "contentType": "application/json"
  },
  "get_documenti_consulente": {
    "path": "/consulenti/{consulenteUuid}/studio/{studioUuid}/documenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "consulenteUuid",
        "description": "UUID del Consulente Legale",
        "required": true
      },
      {
        "name": "studioUuid",
        "description": "UUID dello Studio",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "deleted",
        "description": "Se true, include anche i documenti eliminati (soft-delete).",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_documenti_firmati_consulente": {
    "path": "/consulenti/{uuid}/studio/{id}/documenti/firmati",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      },
      {
        "name": "id",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_documenti_cancellati_consulente": {
    "path": "/consulenti/{uuid}/studio/{id}/documenti_cancellati",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      },
      {
        "name": "id",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_documento": {
    "path": "/documento/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_cancella_documento": {
    "path": "/documento/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento da rimuovere.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.document.notDeletableDocument"
    ],
    "contentType": "application/json"
  },
  "post_app_documento_ripristinadocumento": {
    "path": "/documento/{uuid}/ripristina",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_documento_getdocumentofirmato": {
    "path": "/documento/{uuid}/firmato",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "OpenDotCom",
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_documento_getdocumentoultimato": {
    "path": "/documento/{uuid}/ultimato",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "OpenDotCom",
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_documento_non_firmato": {
    "path": "/documento/{uuid}/non_firmato",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_document_info": {
    "path": "/documento/{uuid}/info",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti",
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_documento_sollecitafirma": {
    "path": "/documento/{uuid}/sollecita_firma",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_annulla_firma": {
    "path": "/documento/{uuid}/annulla_firma",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_documento_timeline": {
    "path": "/documento/{uuid}/timeline",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento di cui ottenere la timeline delle transizioni.",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "page",
        "description": "Numero della pagina da visualizzare.",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Numero di elementi per pagina.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_trasforma_template": {
    "path": "/documento/{uuid}/trasforma_template",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento da trasformare in template.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.document.deletedDocument",
      "exception.system.decodingSecret",
      "exception.aws.errorDocumentNotFound",
      "exception.systemError.genericError"
    ],
    "contentType": "application/json"
  },
  "post_snapshot_versioni_documento": {
    "path": "/documento/{uuid}/snapshot",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del documento di cui creare la snapshot.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.document.deletedDocument"
    ],
    "contentType": "application/json"
  },
  "post_modifica_scadenza_contratto": {
    "path": "/documento/{uuid}/scadenza",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_scelta_tipologia_firma": {
    "path": "/documento/{uuid}/tipologia_firma",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_modifica_firmatari": {
    "path": "/documento/{uuid}/firmatari",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Documenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_event_logs": {
    "path": "/event_logs",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Event Log"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "studioUuid",
        "description": "Filtra eventi collegati allo studio.",
        "required": false
      },
      {
        "name": "userUuid",
        "description": "Filtra eventi collegati a utente attore o target.",
        "required": false
      },
      {
        "name": "documentUuid",
        "description": "Filtra eventi collegati al documento.",
        "required": false
      },
      {
        "name": "entityType",
        "description": "Tipo entita generica collegata.",
        "required": false
      },
      {
        "name": "entityUuid",
        "description": "UUID entita generica collegata.",
        "required": false
      },
      {
        "name": "from",
        "description": "Data/ora minima ISO 8601.",
        "required": false
      },
      {
        "name": "to",
        "description": "Data/ora massima ISO 8601.",
        "required": false
      },
      {
        "name": "method",
        "description": "Metodo HTTP.",
        "required": false
      },
      {
        "name": "routeName",
        "description": "Nome route Symfony.",
        "required": false
      },
      {
        "name": "fornitore",
        "description": "Nome fornitore.",
        "required": false
      },
      {
        "name": "statusCode",
        "description": "Status code HTTP.",
        "required": false
      },
      {
        "name": "page",
        "description": "Pagina zero-based.",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Elementi per pagina.",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_feedbacks": {
    "path": "/api/feedbacks",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Feedbacks"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_forgot_password": {
    "path": "/forgot_password",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_change_password": {
    "path": "/change_password",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_fornitore": {
    "path": "/fornitori/request",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_fornitore_favicon": {
    "path": "/fornitori/favicon",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_lista_fornitori": {
    "path": "/fornitori",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_fornitore": {
    "path": "/fornitori",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_elimina_fornitore": {
    "path": "/fornitori/{id}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": [
      {
        "name": "id",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_modifica_fornitore": {
    "path": "/fornitori/{id}",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Fornitore"
    ],
    "pathParams": [
      {
        "name": "id",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_piano": {
    "path": "/api/studi/{uuid}/cambia_piano",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio da aggiornare.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_piano_studio_admin": {
    "path": "/api/studi/{uuid}/piano",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_piano_studio_user": {
    "path": "/api/studi/{uuid}/piano/user",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_estendi_validita_piano": {
    "path": "/api/studi/{uuid}/estendi_validita_piano",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio.",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.system.planActionForbidden"
    ],
    "contentType": "application/json"
  },
  "post_studio_cancel_subscription": {
    "path": "/api/studi/{uuid}/subscription",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.system.planActionForbidden",
      "exception.system.pianoNonSupportato",
      "exception.stripe.apiCallFailed"
    ],
    "contentType": "application/json"
  },
  "post_send_help": {
    "path": "/help",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_importdocument_getfilewebhook": {
    "path": "/files/webhook",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Webhooks"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "authentication",
        "description": null,
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "post_app_importdocument_creafilesstudio": {
    "path": "/documento/{uuid}/files",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Import DOCX"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "post_infocert_notify": {
    "path": "/envelopes/{identifier}/notify",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Infocert"
    ],
    "pathParams": [
      {
        "name": "identifier",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_well_known_jwks": {
    "path": "/.well-known/jwks.json",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "System"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_login_login": {
    "path": "/api/login_check",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Authentication"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_preview_acquisto": {
    "path": "/studio/{uuid}/preview",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Acquisto Firme"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_acquisto": {
    "path": "/studio/{uuid}/acquisto",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Acquisto Firme"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_notification_send_to_same_studio_user": {
    "path": "/notifications/studio/utenti/{userUuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Notifiche"
    ],
    "pathParams": [
      {
        "name": "userUuid",
        "description": "UUID del consulente destinatario",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_notification_send_as_staff": {
    "path": "/notifications/staff/utenti/{userUuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Notifiche"
    ],
    "pathParams": [
      {
        "name": "userUuid",
        "description": "UUID del destinatario",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_piani": {
    "path": "/piani",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "registrazione",
        "description": "Se true restituisce solo i piani disponibili in fase di registrazione",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_create_piano": {
    "path": "/piani",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_a_piano": {
    "path": "/piani/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_update_piano": {
    "path": "/piani/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_elimina_piano": {
    "path": "/piani/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_minimum_plan": {
    "path": "/piani/suggest/minimum",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Piani"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "permessi",
        "description": "Array di permessi richiesti",
        "required": true
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_register_consulente": {
    "path": "/register/consulente",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Registrazione"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_register_consulente": {
    "path": "/register/consulente",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Registrazione"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_register_studio": {
    "path": "/register/studio",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Registrazione"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "patch_change_plan": {
    "path": "/studio/{uuid}/patch_plan",
    "apiMethod": "patch",
    "responseType": "json",
    "tags": [
      "Registrazione"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_app_whois": {
    "path": "/whois/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Registrazione"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_confirm_code": {
    "path": "/api/confirm-code",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Registrazione",
      "Registrazione"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_sessioni_multidocumentoutente": {
    "path": "/multidocumentoutente/{uuid}/sessioni",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_chat_history": {
    "path": "/ai/sessions/{uuid}/history",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_cancella_session": {
    "path": "/ai/sessions/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID della sessione locale",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_sessioni_utente": {
    "path": "/utente/{uuid}/sessioni",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_studio_analyzer": {
    "path": "/studio/{uuid}/analyzer",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del MultiDocumento",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "post_ai_genera_parere": {
    "path": "/studio/{uuidStudio}/genera_parere",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuidStudio",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "post_standalone_ai_genera_parere_b2b": {
    "path": "/standalone/genera_parere",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "multipart/form-data"
  },
  "get_standalone_sessions_list": {
    "path": "/studio/{uuid}/sessioni_standalone",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "toolType",
        "description": "Tipologia tool (obbligatorio)",
        "required": true
      },
      {
        "name": "search",
        "description": "Filtro per match su titolo (contains, case-insensitive)",
        "required": false
      },
      {
        "name": "page",
        "description": "Pagina",
        "required": false
      },
      {
        "name": "itemsPerPage",
        "description": "Elementi per pagina",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_standalone_session_detail": {
    "path": "/sessioni_standalone/{uuidSession}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Session AI"
    ],
    "pathParams": [
      {
        "name": "uuidSession",
        "description": "UUID della sessione standalone",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_payment_infos": {
    "path": "/api/studi/{uuid}/payment_infos",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.stripe.missing.stripeCustomerId",
      "exception.stripe.apiCallFailed"
    ],
    "contentType": "application/json"
  },
  "get_get_consulenti_standard": {
    "path": "/studio/{uuid}/consulenti",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_redattore": {
    "path": "/studio/{uuid}/consulente",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_consulente_da_studio": {
    "path": "/consulente_studio/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'associazione consulente-studio da rimuovere",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_seats_con_consulenti": {
    "path": "/studio/{uuid}/seats",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_studio": {
    "path": "/studio/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_put_info_studio": {
    "path": "/studio/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_app_studio_rimuovifile": {
    "path": "/files/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Studio"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_payment_methods_list": {
    "path": "/studio/{studioUuid}/payment_methods",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_studio_update_customer_info": {
    "path": "/studio/{studioUuid}/update_customer_info",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_studio_stripe_invoices_list": {
    "path": "/studio/{studioUuid}/stripe/invoices",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "limit",
        "description": "Numero massimo di invoices da restituire",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_studio_payment_methods_create_link": {
    "path": "/studio/{studioUuid}/payment_methods/link",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_studio_payment_methods_set_default": {
    "path": "/studio/{studioUuid}/payment_methods/{id}/default",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      },
      {
        "name": "id",
        "description": "ID del PaymentMethod Stripe",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_studio_payment_methods_detach": {
    "path": "/studio/{studioUuid}/payment_methods/{id}/detach",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Studio Stripe"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      },
      {
        "name": "id",
        "description": "ID del PaymentMethod Stripe da scollegare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_platform_configuration": {
    "path": "/platform_configuration",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Configurazione"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": [
      "exception.error"
    ],
    "contentType": "application/json"
  },
  "get_get_templateAnagrafica": {
    "path": "/template_anagrafica/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_modifica_templateAnagrafica": {
    "path": "/template_anagrafica/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_delete_templateAnagrafica": {
    "path": "/template_anagrafica/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_templatesAnagrafica": {
    "path": "/studio/{uuid}/template_anagrafica",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_crea_templateAnagrafica": {
    "path": "/studio/{uuid}/template_anagrafica",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_change_default_templateAnagrafica": {
    "path": "/template_anagrafica/{uuid}/change_default",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Anagrafica"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_template": {
    "path": "/templates/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template da recuperare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_create_template": {
    "path": "/templates/{uuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_app_template_deletetemplate": {
    "path": "/templates/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template da eliminare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_app_template_createmplateperstaff": {
    "path": "/templates/staff",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_templates": {
    "path": "/studi/{studioUuid}/consulenti/{consulenteUuid}/templates",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello studio",
        "required": true
      },
      {
        "name": "consulenteUuid",
        "description": "UUID del consulente legale",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_templates_unificati": {
    "path": "/templates",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "public",
        "description": "Se true, ritorna solo template pubblici",
        "required": false
      },
      {
        "name": "studio",
        "description": "UUID dello studio",
        "required": false
      },
      {
        "name": "utente",
        "description": "UUID dell’utente (deve corrispondere all’utente loggato)",
        "required": false
      }
    ],
    "exceptionCodes400": [
      "exception.template.accessoNegato"
    ],
    "contentType": "application/json"
  },
  "get_admin_templates_unificati": {
    "path": "/admin/templates",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "public",
        "description": "Se true, ritorna i template pubblici",
        "required": false
      },
      {
        "name": "studio",
        "description": "UUID dello studio",
        "required": false
      },
      {
        "name": "utente",
        "description": "UUID del consulente legale",
        "required": false
      },
      {
        "name": "draft",
        "description": "Filtro draft: true = solo draft, false = solo non draft, omesso = tutti",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_draft": {
    "path": "/templates/{uuid}/cambia_draft",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template da aggiornare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_template_studio_stato": {
    "path": "/studi/{uuidStudio}/consulenti/{uuidUser}/templates/{uuidTemplate}/cambia_stato",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuidStudio",
        "description": "UUID dello studio",
        "required": true
      },
      {
        "name": "uuidUser",
        "description": "UUID del consulente legale",
        "required": true
      },
      {
        "name": "uuidTemplate",
        "description": "UUID del template da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_cambia_studio": {
    "path": "/templates/{uuid}/cambia_studio",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del template da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.document.studioNotFound"
    ],
    "contentType": "application/json"
  },
  "post_app_template_aggiungitemplatepreferito": {
    "path": "/utenti/{utenteUuid}/templates/{templateUuid}",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "utenteUuid",
        "description": "UUID dell'utente",
        "required": true
      },
      {
        "name": "templateUuid",
        "description": "UUID del template da aggiungere",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.template.accessoNegato",
      "exception.template.nonTrovato"
    ],
    "contentType": "application/json"
  },
  "delete_app_template_rimuovitemplatepreferito": {
    "path": "/utenti/{utenteUuid}/templates/{templateUuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Template Documento"
    ],
    "pathParams": [
      {
        "name": "utenteUuid",
        "description": "UUID dell'utente",
        "required": true
      },
      {
        "name": "templateUuid",
        "description": "UUID del template da rimuovere",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.template.accessoNegato",
      "exception.template.nonTrovato"
    ],
    "contentType": "application/json"
  },
  "get_tc_list": {
    "path": "/termsandconditions",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "query",
        "description": "Filtro su nome/slug (contains, case-insensitive)",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_tc_create": {
    "path": "/termsandconditions",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": [
      "exception.slug.notValid"
    ],
    "contentType": "application/json"
  },
  "get_tc_get": {
    "path": "/termsandconditions/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_tc_update": {
    "path": "/termsandconditions/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.slug.notValid"
    ],
    "contentType": "application/json"
  },
  "delete_tc_delete": {
    "path": "/termsandconditions/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.slug.notValid"
    ],
    "contentType": "application/json"
  },
  "get_tc_list_no_api": {
    "path": "/termsandconditions/no-api",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_utente_tc_to_accept": {
    "path": "/utenti/{uuid}/termsandconditions",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell’utente destinatario",
        "required": true
      }
    ],
    "queryParams": [
      {
        "name": "studioUuid",
        "description": "UUID dello Studio (opzionale). Se presente e l’utente è admin di questo Studio, verranno incluse anche le T&C di tipo \"studio\".",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_utente_tc_accept": {
    "path": "/utenti/{uuid}/tc",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Terms & Conditions"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": null,
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": [
      "exception.tc.notFound",
      "exception.miss.studioUuid",
      "exception.document.studioNotFound",
      "exception.utente.nonConsulente",
      "exception.utente.studio.notAdmin"
    ],
    "contentType": "application/json"
  },
  "get_tour": {
    "path": "/tours/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Tour"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del Tour",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "delete_a_tour": {
    "path": "/tours/{uuid}",
    "apiMethod": "delete",
    "responseType": "json",
    "tags": [
      "Tour"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del Tour da eliminare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_tours": {
    "path": "/tours",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Tour"
    ],
    "pathParams": null,
    "queryParams": [
      {
        "name": "sezione",
        "description": "La sezione dei tours",
        "required": false
      },
      {
        "name": "isPublished",
        "description": "Filtro opzionale: true = solo pubblici, false = solo non pubblici",
        "required": false
      }
    ],
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_create_tour": {
    "path": "/tours",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Tour"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_edit_tour": {
    "path": "/tours/{uuid}/edit",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Tour"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID del Tour da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_utente": {
    "path": "/utenti/{uuid}",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "put_modifica_utente": {
    "path": "/utenti/{uuid}",
    "apiMethod": "put",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente da modificare",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_ottieni_legalKey": {
    "path": "/utente/legalkey",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_get_studi_utente": {
    "path": "/utenti/{uuid}/studi",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_estendi_forgot_time": {
    "path": "/utenti/{uuid}/estendi_forgot_time",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_add_fcmToken": {
    "path": "/utenti/{uuid}/fcmToken",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_remove_fcmToken": {
    "path": "/utenti/{uuid}/remove_fcmToken",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_verify_email": {
    "path": "/verify_email",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": [
      "exception.systemError.genericError",
      "exception.registration.expiredCode",
      "exception.registration.codeNotValid"
    ],
    "contentType": "application/json"
  },
  "get_get_verification_code": {
    "path": "/get_verification_code",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": [
      "exception.systemError.genericError",
      "exception.registration.expiredCode",
      "exception.registration.codeNotValid"
    ],
    "contentType": "application/json"
  },
  "post_accetta_condizioni": {
    "path": "/utenti/{uuid}/condizioni",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_accetta_consenso_ai": {
    "path": "/utenti/{uuid}/consenso_ai",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_accetta_consenso_ai_document_analyzer": {
    "path": "/utenti/{uuid}/consenso_ai_document_analyzer",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "post_accetta_consenso_ai_document_generator": {
    "path": "/utenti/{uuid}/consenso_ai_document_generator",
    "apiMethod": "post",
    "responseType": "json",
    "tags": [
      "Utenti"
    ],
    "pathParams": [
      {
        "name": "uuid",
        "description": "UUID dell'utente",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_view_pdf": {
    "path": "/view/{encryptedPath}",
    "apiMethod": "get",
    "responseType": "arraybuffer",
    "tags": [
      "View"
    ],
    "pathParams": [
      {
        "name": "encryptedPath",
        "description": "Segmento di path cifrato / encodato che rappresenta l'URL originale del PDF (generato da ViewUrlService::encodeUrl).",
        "required": true
      }
    ],
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_whoami": {
    "path": "/whoami",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  },
  "get_share_whoami": {
    "path": "/share/whoami",
    "apiMethod": "get",
    "responseType": "json",
    "tags": [],
    "pathParams": null,
    "queryParams": null,
    "exceptionCodes400": null,
    "contentType": "application/json"
  }
} as const;

export type ApiOperationId = keyof typeof routesRegistryOpenApi;
export type ApiOperationMeta = typeof routesRegistryOpenApi[ApiOperationId];
